<script setup>
import { ref, watch, useAttrs } from 'vue';
import { debounce, Notify } from 'quasar';
import { useClipboard } from '@vueuse/core';

const attrs = useAttrs();
const source = ref(attrs.text);
const { text, copy, copied, isSupported } = useClipboard({ source });

const menu = ref(false);
const menuOver = ref(false);
const listOver = ref(false);

const debounceFunc = debounce(checkMenu, 10);

function checkMenu() {
  if (menuOver.value || listOver.value) {
    menu.value = true;
  } else {
    menu.value = false;
  }
}
watch([menuOver, listOver], () => {
  debounceFunc();
});

function copying() {
  copy();
  Notify.create({
    message: 'Text Copied!',
    classes: 'bg-green px-4',
  });
}
</script>

<template>
  <div @mouseover="menuOver = true" @mouseout="menuOver = false">
    {{ $attrs.text }}
    <q-menu v-model="menu" persistent auto-close>
      <q-list
        style="min-width: 100px"
        dense
        @mouseover.native="listOver = true"
        @mouseout.native="listOver = false"
      >
        <q-item clickable v-close-popup class="p-5" @click="copying"
          >{{ $attrs.text }} <q-icon name="content_copy" />
        </q-item>
      </q-list>
    </q-menu>
  </div>
</template>
